import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./nevbar.css";

const Navbar = () => {
  const location = useLocation(); 

  return (
    <>
      <nav className="navbar navbar-blue">
        <div className="container d-flex justify-content-between align-items-center">

          {/* โลโก้ */}
          <div className="navbar-logo">
            <Link to="/">
              <img src="/RegisterAssoc/logo-1.png" alt="Logo" className="logo-img" />
            </Link>
          </div>

          {/* ลิงก์ด้านขวา */}
          <div className="navbar-links">
            <button
              className="btn btn-light mx-2"
              onClick={() => (window.location.href = "https://mualumni.mahidol.ac.th/")}
            >
              <strong>หน้าแรก</strong>
            </button>
            <Link
              to="/"
              className={`btn mx-2 ${location.pathname === "/" ? "active" : "btn-light"}`}
            >
              <strong>สมัครสมาชิก</strong>
            </Link>
            <Link
              to="/member"
              className={`btn mx-2 ${location.pathname === "/member" ? "active" : "btn-light"}`}
            >
              <strong>ตรวจสอบการสมัครสมาชิก</strong>
            </Link>
            <Link
              to="/Check"
              className={`btn mx-2 ${location.pathname === "/Check" ? "active" : "btn-light"}`}
            >
              <strong>ตรวจสอบเลขที่สมาชิก</strong>
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
